import React, { createContext, useContext, useMemo, useState } from 'react';
import { ThemeProvider } from '@mui/material';
import Theme from '../../assets/styles/Theme';

interface ThemeModeContextType {
  contrastMode: boolean;
  toggleContrastMode: () => void;
}

const ThemeModeContext = createContext<ThemeModeContextType>({
  contrastMode: false,
  toggleContrastMode: () => {},
});

export const useThemeMode = () => useContext(ThemeModeContext);

export const ThemeModeProvider = ({ children }: { children: React.ReactNode }) => {
  const [contrastMode, setContrastMode] = useState(false);

  const toggleContrastMode = () => setContrastMode((prev) => !prev);

  const theme = useMemo(() => Theme(contrastMode), [contrastMode]);

  return (
    <ThemeModeContext.Provider value={{ contrastMode, toggleContrastMode }}>
      <ThemeProvider theme={theme}>{children}</ThemeProvider>
    </ThemeModeContext.Provider>
  );
};
